import React from 'react';
import { Backdrop, SpeedDial, SpeedDialAction, SpeedDialIcon, Zoom } from '@mui/material';

import { type MiddlewhereFilter } from 'app/main/components/filter/FilterItemManager';
import { type FiltersType } from 'app/main/components/hooks/useFilters';
import { type QueryType } from 'app/main/components/hooks/useQuery';
import useSettings from 'app/main/components/hooks/useSettings';
import Icon from 'app/main/components/Icon';
import FilterDialog from 'app/main/components/filter/FilterDialog';
import QueryBuilderDialog from 'app/main/components/filter/QueryBuilderDialog';
import BoardSearchDialog from './BoardSearchDialog';

interface BoardFabProps {
	module: string;
	filterProps: {
		defaultFilters?: MiddlewhereFilter[];
		defaultQuery?: any;
	} & FiltersType &
		QueryType;
}

export default function BoardFab({ module, filterProps }: BoardFabProps) {
	const { t } = useSettings();

	const [menuOpen, setMenuOpen] = React.useState(false);

	const [openSearchDialog, setOpenSearchDialog] = React.useState(false);
	const [openFilterDialog, setOpenFilterDialog] = React.useState(false);
	const [openQueryBuilder, setOpenQueryBuilder] = React.useState(false);

	const actions = [
		{
			icon: 'search',
			name: t('SEARCH_BUTTON'),
			onClick: () => setOpenSearchDialog(true)
		},
		{
			icon: 'filter',
			name: t('FILTER_BUTTON'),
			onClick: () => setOpenFilterDialog(true)
		},
		{
			icon: 'file-tree',
			name: t('FILTER_QUERY_BUILDER_BUTTON'),
			onClick: () => setOpenQueryBuilder(true)
		},
		{
			icon: 'filter-off',
			name: t('FILTER_CLEAR_BUTTON'),
			onClick: () => {
				filterProps.handleFiltersClear();
				filterProps.handleQueryClear();
			}
		}
	].reverse();

	return (
		<>
			<Backdrop open={menuOpen} />
			<Zoom in unmountOnExit>
				<SpeedDial
					className="fixed bottom-12 right-12"
					ariaLabel="Kanban board actions"
					icon={<SpeedDialIcon icon={<Icon icon="tune" />} openIcon={<Icon icon="close" />} />}
					open={menuOpen}
					onOpen={() => setMenuOpen(true)}
					onClose={() => setMenuOpen(false)}
				>
					{actions.map(action => (
						<SpeedDialAction
							key={action.name}
							icon={<Icon icon={action.icon} />}
							tooltipTitle={action.name}
							tooltipOpen
							onClick={() => {
								action.onClick();
								// handleMenuClose();
							}}
						/>
					))}
				</SpeedDial>
			</Zoom>
			<BoardSearchDialog
				open={openSearchDialog}
				closeDialog={() => setOpenSearchDialog(false)}
				module={module}
				filters={filterProps.filters}
				handleFilterChange={filterProps.handleFilterChange}
				handleFiltersApply={filterProps.handleFiltersApply}
				// handleFilterChangeApply={filterProps.handleFilterChangeApply}
			/>
			<FilterDialog
				open={openFilterDialog}
				closeDialog={() => setOpenFilterDialog(false)}
				module={module}
				defaultFilters={filterProps.defaultFilters || []}
				currentFilters={filterProps.currentFilters}
				setCurrentFilters={filterProps.setCurrentFilters}
				handleFilterChange={filterProps.handleFilterChange}
				handleFiltersApply={filterProps.handleFiltersApply}
			/>
			<QueryBuilderDialog
				open={openQueryBuilder}
				closeDialog={() => setOpenQueryBuilder(false)}
				currentQuery={filterProps.currentQuery || filterProps.defaultQuery}
				currentTree={filterProps.currentTree}
				queryConfig={filterProps.queryConfig}
				handleQueryClear={filterProps.handleQueryClear}
				handleQueryChange={filterProps.handleQueryChange}
				handleQueryApply={filterProps.handleQueryApply}
			/>
		</>
	);
}
